import { isEmbedded as detectEmbedded } from '@/utils/embed';
import { useReplaceTargetValidationId } from '@/stores/embedStore';
import { usePreviewEmbedded } from '@/stores/devOverridesStore';

export type EmbedMode = 'standalone' | 'create' | 'replace';

export const useEmbedMode = (): EmbedMode => {
  const replaceTargetId = useReplaceTargetValidationId();
  const previewEmbedded = usePreviewEmbedded();
  if (!detectEmbedded() && !previewEmbedded) return 'standalone';
  return replaceTargetId ? 'replace' : 'create';
};

export const useIsEmbedded = (): boolean => useEmbedMode() !== 'standalone';
